import { ApiResponse } from '@restaurant/types';
import { Menu } from '../types';
import http from '~/http';

export const fetchAddOnMenu = () => {};

export type SearchMenuRequest = {
  page?: number;
  size?: number;
  sort: SearchMenuSort[];
  filters?: SearchMenuFilters;
};

export type SearchMenuSort = {
  field: string;
  order: string;
};

export type SearchMenuFilters = {
  categoryIds?: string[];
  menuKeyword?: string;
};

export type SearchMenuResponseData = {
  page: number;
  size: number;
  totalPages: number;
  totalElements: number;
  menus: Menu[];
};

const SEARCH_MENU_URL = '/api/v1/menus/search';

export type SearchMenuResponse = ApiResponse<SearchMenuResponseData>;
export const searchMenus = (req: SearchMenuRequest) => {
  return http.post<SearchMenuResponse>(SEARCH_MENU_URL, req);
};

export type GetMenuResponse = ApiResponse<Menu>;
export const getMenu = (id: string) => {
  return http.get<GetMenuResponse>(`/api/v1/menus/${id}`);
};

export type GetCategoryAndMenu = {
  id: string;
  name: string;
  seq: number;
  items: GetCategoryAndMenuItem[];
};

export type GetCategoryAndMenuItem = {
  id: string;
  name: string;
};

export type GetCategoryAndMenuResponse = ApiResponse<GetCategoryAndMenu[]>;
export const getCategoryAndMenu = () => {
  return http.get<GetCategoryAndMenuResponse>('/api/v1/menu');
};

export type GenerateSequenceResponse = ApiResponse<number>;
export const generateSequence = (categoryId: string) => {
  return http.get<GenerateSequenceResponse>(
    `/api/v1/menus/sequences?categoryId=${categoryId}`
  );
};

export type CreateMenuRequest = {
  menus: Menu[];
};

export type CreateMenuResponse = ApiResponse<null>;
export const createMenu = (menu: Menu) => {
  const req = { menus: [menu] };
  return http.post<CreateMenuResponse>('/api/v1/menus', req);
};

export type UpdateMenuResponse = ApiResponse<null>;
export const updateMenu = (menu: Menu) => {
  return http.put<UpdateMenuResponse>(`/api/v1/menus/${menu.id}`, menu);
};
